/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Push_Endpoint_TakenInputs */

const en_error_push_endpoint_taken = /** @type {(inputs: Error_Push_Endpoint_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser was receiving the notifications of someone else. Turn them on again to receive yours.`)
};

/**
* | output |
* | --- |
* | "This browser was receiving the notifications of someone else. Turn them on again to receive yours." |
*
* @param {Error_Push_Endpoint_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_push_endpoint_taken = /** @type {((inputs?: Error_Push_Endpoint_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Push_Endpoint_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_push_endpoint_taken(inputs)
});